<div class="skeleton-card">
  <div class="spinner-wrapper">
    <mat-spinner class="blue-spinner" [diameter]="60"></mat-spinner>
  </div>
</div>
